export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6529.33076919.jpg";